import ShopOrderService from '@/services/ShopOrderService'
import OrderModel from '@/models/OrderModel'
import Mtxs from '@/constants/Mutations'

export const state = {} // state

export const mutations = {} // mutations

export const getters = {
  getShopOrders: (_, __, ___, rootGetters) => {
    let shopId = rootGetters['shop/getShopId']
    return OrderModel.query()
      .where('shop_id', shopId)
      .get()
  },
} // getters

export const actions = {
  async fetchShopOrders() {
    try {
      await OrderModel.fetchForShop()
    } catch (error) {
      throw Error(error)
    }
  }, // fetchShopOrders
  async updateShopOrder({ commit, rootGetters }, { orderId, newValues }) {
    try {
      const shopId = rootGetters['shop/getShopid']
      if (!shopId || !orderId) {
        throw new Error('A shopId and orderId must be provided')
      }
      const updatedShopOrder = await ShopOrderService.update(
        shopId,
        orderId,
        newValues
      )
      commit(`order/${Mtxs.SET_ORDER}`, updatedShopOrder, { root: true })
      return updatedShopOrder
    } catch (error) {
      Promise.reject(error)
    }
  }, // updateShopOrder
} // actions

export const namespaced = true
